<template>
  <div class="activities-page">
    <!-- Hero Section -->
    <section class="hero">
      <img class="hero-image" src="https://www-img.sanfu.com/production/activities_top.png" alt="" />
    </section>

    <!-- Activities Grid -->
    <section class="activities">
      <div class="container">
        <div class="section-header">
          <h2 class="section-title">
            {{ locale === 'zh' ? '品牌动态' : locale === 'en' ? 'Brand Dynamics' : 'Brand News' }}
          </h2>
          <p class="section-description">
            {{ locale === 'zh' ? '探索丰富多彩的品牌动态，见证无限精彩瞬间' : locale === 'en' ? 'Explore our diverse brand dynamics and witness infinite wonderful moments' : 'Jelajahi dinamika merek yang beragam dan saksikan momen-momen indah tak terbatas' }}
          </p>
        </div>
        <!-- <div class="activities-filter">
          <button v-for="category in categories" :key="category.id" @click="activeCategory = category.id" :class="['filter-btn', { active: activeCategory === category.id }]">
            {{ category.name }}
          </button>
        </div> -->

        <div class="activities-grid">
          <NuxtLinkLocale v-for="activity in activities" :key="activity.id" class="activity-card" @click="openDetail(activity)" :to="activity.hasRichText && activity.id ? `/activities/${activity.id}` : undefined">
            <div class="image-wrap">
              <el-image fit="cover" :src="activity.img" class="image-placeholder" alt="" />
              <!-- <div class="activity-badge">{{ activity.category }}</div> -->
            </div>
            <div class="activity-content">
              <div class="activity-meta">
                <span class="activity-date">{{ activity.date }}</span>
                <span class="activity-location">{{ activity.location }}</span>
              </div>
              <h3 class="activity-title">{{ activity.title }}</h3>
              <p class="activity-description">{{ activity.description }}</p>
              <!-- <div class="activity-footer">
                <div class="activity-stats">
                  <span class="stat">
                    <svg viewBox="0 0 20 20" fill="currentColor">
                      <path d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"/>
                    </svg>
                    {{ activity.participants }}{{ locale === 'zh' ? '人参与' : locale === 'en' ? ' participants' : ' peserta' }}
                  </span>
                </div>
                <button class="learn-more-btn">
                  {{ locale === 'zh' ? '了解更多' : locale === 'en' ? 'Learn More' : 'Pelajari Lebih Lanjut' }}
                </button>
              </div> -->
            </div>
          </NuxtLinkLocale>
        </div>

        <!-- 图片画廊组件 -->
        <ImageGallery v-model="galleryVisible" :images="galleryImages" :title="galleryTitle" @close="galleryVisible = false" />
      </div>
    </section>
  </div>
</template>

<script setup>
  import { ref, computed } from 'vue'

  useHead({
    title: '品牌动态 - SANFU',
    meta: [{ name: 'description', content: '了解我们的品牌动态，见证无限精彩瞬间' }]
  })

  const { locale } = useI18n()
  const activeCategory = ref('all')
  // 轮播图数据（初始为空，将通过API获取）
  const activities = ref([])

  // 使用 useAsyncData 获取banner数据，支持SSR，避免水合错误
  const { data: res } = await useAsyncData(
    'activitiesData',
    () =>
      $fetch('/api/banner/getList', {
        method: 'GET',
        params: {
          type: 4,
          pageSize: 9,
          locale: locale.value
        }
      }),
    { watch: [locale] }
  )
  const data = res.value?.data
  // 如果获取数据成功，更新轮播图数据
  if (data && Array.isArray(data) && data.length) {
    activities.value = data
  }

  // 画廊相关状态
  const galleryVisible = ref(false)
  const galleryImages = ref([])
  const galleryTitle = ref('')

  // 打开详情
  const openDetail = activity => {
    // 如果有富文本内容或需要详细展示，跳转到详情页
    if (activity.hasRichText && activity.id) {
      return
    }

    // 否则显示图片画廊
    const images = [activity.img]
    if (activity.imgList && Array.isArray(activity.imgList)) {
      images.push(...activity.imgList)
    }

    galleryImages.value = images
    galleryTitle.value = activity.title[locale.value]
    galleryVisible.value = true
  }
</script>

<style scoped lang="less">
  .hero {
    padding: var(--space-10) 0 0;
    background: linear-gradient(0deg, var(--gray-100) 0%, var(--white) 100%);
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  .hero-content {
    max-width: 800px;
    margin: 0 auto;
    margin-bottom: 3%;
    text-align: center;
  }

  .hero-title {
    font-size: 48px;
    font-weight: 700;
    margin-bottom: var(--space-6);
    color: var(--gray-900);
  }

  .hero-description {
    font-size: var(--text-xl);
    color: var(--gray-600);
    line-height: 1.6;
  }

  .hero-image {
    width: 70%;
    object-fit: contain;
    opacity: 0.95;
  }

  .activities {
    padding: var(--space-12) 0;
  }

  .section-header {
    text-align: center;
    margin-bottom: var(--space-12);
  }

  .section-title {
    font-size: var(--text-3xl);
    font-weight: 600;
    margin-bottom: var(--space-4);
    color: var(--gray-900);
  }

  .section-description {
    font-size: var(--text-lg);
    color: var(--gray-600);
    max-width: 600px;
    margin: 0 auto;
  }

  .activities-filter {
    display: flex;
    justify-content: center;
    gap: var(--space-4);
    margin-bottom: var(--space-12);
    flex-wrap: wrap;
  }

  .filter-btn {
    padding: var(--space-3) var(--space-6);
    border: 2px solid var(--gray-300);
    background-color: var(--white);
    color: var(--gray-600);
    border-radius: var(--radius-full);
    font-weight: 500;
    cursor: pointer;
    transition: all var(--transition-fast);
  }

  .filter-btn:hover {
    border-color: var(--primary);
    color: var(--primary);
  }

  .filter-btn.active {
    background-color: var(--primary);
    border-color: var(--primary);
    color: var(--white);
  }

  .activities-grid {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(350px, 1fr));
    gap: var(--space-8);
  }

  .activity-card {
    background-color: var(--white);
    border-radius: var(--radius-xl);
    overflow: hidden;
    box-shadow: var(--shadow);
    transition: all var(--transition-base);
  }

  .activity-card:hover {
    transform: translateY(-8px);
    box-shadow: var(--shadow-lg);
    cursor: pointer;
  }

  .image-wrap {
    position: relative;
    padding-top: 56.25%;
    width: 100%;
  }

  .image-placeholder {
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    left: 0;
  }

  .activity-badge {
    position: absolute;
    top: var(--space-4);
    left: var(--space-4);
    background-color: rgba(255, 255, 255, 0.9);
    padding: var(--space-2) var(--space-3);
    border-radius: var(--radius);
    font-size: var(--text-sm);
    font-weight: 500;
  }

  .activity-content {
    padding: var(--space-6);
  }

  .activity-meta {
    display: flex;
    gap: var(--space-4);
    margin-bottom: var(--space-4);
    font-size: var(--text-sm);
    color: var(--gray-500);
  }

  .activity-title {
    font-size: var(--text-xl);
    font-weight: 600;
    margin-bottom: var(--space-3);
    color: var(--gray-900);
  }

  .activity-description {
    color: var(--gray-600);
    line-height: 1.6;
    margin-bottom: var(--space-4);
  }

  .activity-footer {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .stat {
    display: flex;
    align-items: center;
    gap: var(--space-2);
    font-size: var(--text-sm);
    color: var(--gray-500);
  }

  .stat svg {
    width: 16px;
    height: 16px;
  }

  .learn-more-btn {
    padding: var(--space-2) var(--space-4);
    background-color: var(--primary);
    color: var(--white);
    border: none;
    border-radius: var(--radius);
    font-weight: 500;
    cursor: pointer;
    transition: background-color var(--transition-fast);
  }

  .learn-more-btn:hover {
    background-color: var(--primary-dark);
  }

  /* 横版布局样式 */
  .horizontal-layout {
    display: flex !important;
    flex-direction: column;
    gap: var(--space-6);
    .activity-card {
      display: flex;
      flex-direction: row;
      border-radius: var(--radius-xl);
      overflow: hidden;
      box-shadow: var(--shadow);
      transition: all var(--transition-base);
    }
    .activity-card:hover {
      transform: translateY(-4px);
      box-shadow: var(--shadow-lg);
    }
    .image-wrap {
      position: relative;
      width: 24%;
      padding-top: calc(30% * 0.75); /* 4:3 比例 */
      min-width: 240px;
    }
    .activity-content {
      flex: 1;
      padding: var(--space-6);
      display: flex;
      flex-direction: column-reverse;
      justify-content: space-between;
    }
  }

  @media (max-width: 768px) {
    .hero-title {
      font-size: var(--text-3xl);
    }

    .hero-image {
      width: 100%;
      object-fit: contain;
    }

    .activities-grid {
      grid-template-columns: 1fr;
    }

    /* 移动端横版布局调整 */
    .horizontal-layout .activity-card {
      flex-direction: column;
      .image-wrap {
        width: 100%;
        padding-top: 56.25%;
        min-width: auto;
      }
      .activity-content {
        padding: var(--space-4);
      }
    }

    .activities-filter {
      justify-content: flex-start;
      overflow-x: auto;
      padding-bottom: var(--space-2);
    }

    .filter-btn {
      white-space: nowrap;
    }
  }
</style>
